import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F1F4F3]">
        <span className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#8797A3] animate-pulse">Verifying…</span>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
};
